module.exports = __webpack_public_path__ + "img/casinovibez.c82456fa.svg";